import {useEffect, useState} from 'react';

import {cutTimeLabel, durationUntil} from '../utilities';

export default function EventCountdown({
    entryEndsAt,
    startsAt,
    fallback,
    to,
    prefix = 'Closes in',
}: {
    entryEndsAt?: string | null;
    startsAt?: string | null;
    fallback?: string;
    to?: string | null;
    prefix?: string;
}) {
    const [, setTick] = useState(0);

    useEffect(() => {
        const id = window.setInterval(() => setTick((t) => t + 1), 1000);
        return () => window.clearInterval(id);
    }, []);

    if (to !== undefined) {
        const dur = durationUntil(to);
        return <>{dur ? `${prefix} ${dur}` : (fallback || '')}</>;
    }
    return <>{cutTimeLabel(entryEndsAt, startsAt, fallback)}</>;
}
